import ClienteService from "../cliente/clienteService";
import FazendaService from "../fazenda/fazendaService";
import UsuarioService from "../usuario/usuarioService";
import UsuarioClienteService from "../usuarioClienteVinculo/usuarioClienteVinculoService";
import BenchmarkService from "./benchmarkService";

class BenchmarkManager {
  async obtemAcessoUsuario(email) {
    return BenchmarkService.obtemAcessoUsuarioAoBenchmark(email);
  }

  async gerenciarAcesso(email, acessaBenchmark, nomeUsuario, associacoes) {
    const body = acessaBenchmark
      ? { action: "grant", name: nomeUsuario, associations: associacoes }
      : { action: "revoke" };
    return BenchmarkService.gerenciarAcessoBenchmark(email, body);
  }

  async obtemAssociacoesUsuario(IdUsuario) {
    const [clientesUsuarioResp, fazendasUsuarioResp] = await Promise.all([
      UsuarioClienteService.obtemClientesUsuario(IdUsuario),
      UsuarioService.obtemFazendasUsuario(IdUsuario),
    ]);

    const vinculos = clientesUsuarioResp.data || [];
    const fazendasUsuario = (fazendasUsuarioResp.data || []).filter(
      (f) => !f.Excluido,
    );

    const idsClientes = vinculos.map((v) => v.IdCliente);
    const idsFazendasUsuario = fazendasUsuario.map((f) => f.IdFazenda);

    if (!idsClientes.length || !idsFazendasUsuario.length) {
      return [];
    }

    const fazendasResponse = await FazendaService.obtemFazendas(
      `?filter=${JSON.stringify({ where: { IdFazenda: idsFazendasUsuario } })}`,
    );
    const fazendas = fazendasResponse.data || [];

    const fazendasPorCliente = {};
    for (const fazenda of fazendas) {
      if (idsClientes.includes(fazenda.IdCliente)) {
        if (!fazendasPorCliente[fazenda.IdCliente]) {
          fazendasPorCliente[fazenda.IdCliente] = [];
        }
        fazendasPorCliente[fazenda.IdCliente].push(fazenda.Nome);
      }
    }

    const idsClientesComFazendas = Object.keys(fazendasPorCliente).map(Number);
    if (!idsClientesComFazendas.length) {
      return [];
    }

    const clientesResponses = await Promise.all(
      idsClientesComFazendas.map((id) => ClienteService.obtemClientePorId(id)),
    );

    const nomesClientes = {};
    clientesResponses.forEach((resp) => {
      const cliente = resp.data;
      if (cliente) {
        const dados = Array.isArray(cliente) ? cliente[0] : cliente;
        if (dados) {
          nomesClientes[dados.IdCliente] = dados.Nome;
        }
      }
    });

    const benchmarkPromises = idsClientesComFazendas
      .filter((idCliente) => nomesClientes[idCliente])
      .map((idCliente) => {
        const nomeCliente = nomesClientes[idCliente];
        const nomeFazendas = fazendasPorCliente[idCliente].join(",");
        return BenchmarkService.obtemAcessoFazendasClienteBenchmark(
          nomeCliente,
          nomeFazendas,
        ).then((data) => ({
          nomeCliente,
          fazendas: (data.farms_access || []).map((f) => ({
            name: f.farm_name,
            has_access: f.has_access,
          })),
        }));
      });

    return Promise.all(benchmarkPromises);
  }
}

export default new BenchmarkManager();
